import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getReportOperators = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/operators?${queries}` });

  return data;
};

export default getReportOperators;
